var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 155,
    viewBox: "0 0 184 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 134V34H159V18H61V2H5V134C5 145.048 13.944 154 25 154C36.04 154 45 145.048 45 134Z",
    fill: "#F2F4FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 134.5C41 145.548 31.846 153 20.875 153C9.8881 153 1 144.048 1 133V1H56.65V17H160V33",
    stroke: "#A5A8BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7952 44.9377L35.8103 27.8921L52.2258 15.2288C52.8382 14.7563 53.59 14.5 54.3636 14.5H93H169C170.933 14.5 172.5 16.067 172.5 18V137C172.5 138.933 170.933 140.5 169 140.5H17C15.067 140.5 13.5 138.933 13.5 137V77.5V47.6559C13.5 46.601 13.9759 45.6023 14.7952 44.9377Z",
    fill: "#E0E5F0",
    stroke: "#A5A8BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170 17L54 17",
    stroke: "#F2F4FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.735 53.9331L48.8147 36.8887L65.2258 24.2288C65.8382 23.7563 66.59 23.5 67.3636 23.5H107H169C170.933 23.5 172.5 25.067 172.5 27V137C172.5 138.933 170.933 140.5 169 140.5H31C29.067 140.5 27.5 138.933 27.5 137V85.5V56.6014C27.5 55.5738 27.9516 54.5981 28.735 53.9331Z",
    fill: "#F2F4FA",
    stroke: "#A5A8BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169 26L67 26",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.293 154.436L22.1646 154.999C32.9943 154.911 41.7561 146.11 41.7561 135.261V35.564L184 35V130.749C184 143.832 173.371 154.436 160.293 154.436Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157 150V150C168.985 150.545 179 140.975 179 128.977V37",
    stroke: "#F2F4FA",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.293 151.936L159.291 151.936L27.3835 152.474C35.44 149.802 41.2561 142.211 41.2561 133.261V35.062L182.5 34.502V128.749C182.5 141.555 172.096 151.936 159.293 151.936Z",
    stroke: "#A5A8BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoDocuments);
export default __webpack_public_path__ + "static/media/ic-no-documents.efc29dc09c18a063d359ca6353434f3f.svg";
export { ForwardRef as ReactComponent };